import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=7b056d06&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=7b056d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b056d06",
  null
  
)

export default component.exports